import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { catchError, throwError } from 'rxjs';
import { AlertService, KeycloakService } from '@muvstok/ngx-muvstok';

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloakService = inject(KeycloakService);
  const alertService = inject(AlertService);
  if (!req) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error instanceof ErrorEvent) {
        // Client-side or network error
        const message = `Client Error: ${error.error.message}`;
        console.error(message);
        alertService.error(message);
      } else {
        // Backend error
        if (req.url.indexOf('auth/validateAccess') >= 0) {
          return throwError(() => error);
        }
        if (error.status === 401) {
          localStorage.clear();
          keycloakService.logout();
        }

        if (error != null && error.error != null && error.error.data != null && Array.isArray(error.error.data)) {
          const mensagem = error.error.data.join('\r\n');
          alertService.error(mensagem);
        } else if (error != null && error.error != null && error.error.message != null) {
          alertService.error(error.error.message);
        } else {
          alertService.error(error.message);
        }
      }

      return throwError(() => error);
    }),
  );
};
